export const getDifficultyDetails = (wpm) => {
  let color, icon;

  if (wpm < 10) {
    color = "#06d6a0"; // Easy (Green)
    icon = "fas fa-lightbulb";
  } else if (wpm >= 10 && wpm < 15) {
    color = "#3f88c5"; // Medium (Blue)
    icon = "fas fa-trophy";
  } else if (wpm >= 15 && wpm <= 20) {
    color = "#ef476f"; // Hard (Red)
    icon = "fas fa-skull";
  } else if (wpm > 20) {
    color = "#f39c12"; // Extra Hard (Yellow)
    icon = "fas fa-crown";
  } else {
    color = "#b0b0b0"; // Default (Grey)
    icon = "fas fa-book";
  }

  return { color, icon };
};
